<template>
  <section>
    <div v-if="loadingStatus">
      <ContentLoader :size="4"></ContentLoader>
    </div>
    <div class="grid lg:grid-cols-4 md:grid-cols-2 gap-2" v-else>
      <div v-for="(d, i) in data" :key="i">
        <button
          @click="detailPageHandler(d)"
          v-if="d.entity_type == 2"
        >
          <Tooltip
            trigger="hover"
            :options="{
              placement: 'bottom',
              modifiers: { offset: { offset: '0,2px' } },
            }"
          >
            <div
              class="flex shadow h-full p-2 items-center border-1 border-borderColor m-1 rounded-lg"
              slot="reference"
              :class="(d.transaction_status && d.transaction_status === 'refunded') || d.status == 0 ? 'bg-gray-200' : 'bg-white'"
            >
              <img
                class="object-cover h-20 w-20 rounded"
                :src="baseUrlSrc(d.batch_metadata.course_pack_thumbnail_url)"
                alt="..."
                @error="defaultImage"
              />
              <div class="xl:px-2 relative">
                <h5
                  class="captalize text-base font-semibold text-blackgrey mb-1"
                >
                  {{ handleStr(d.batch_metadata.course_pack_title, 14) }}
                  <span v-if="d.is_private">
                    <EyeOff />
                  </span>
                </h5>
                <p class="text-gray-light text-xs mb-1">
                  {{ getFormattedDate(d.start_date, d.timezone, 'MMM DD, YYYY') }}
                </p>
                <p class="text-gray-light text-xs">
                  {{ getFormattedDate(d.start_date, d.timezone, 'h:mm A') }} -
                  {{ getFormattedDate(d.end_date, d.timezone, 'h:mm A') }}
                </p>
                <p
                  v-if="(d.transaction_status && d.transaction_status === 'refunded') || d.status == 0"
                  class="text-xs text-red-medium capitalize font-semibold mt-1"
                >
                  {{d.transaction_status === 'refunded' ? 'Cancelled' : 'Cancelled by Trainer'}}
                </p>
                <p v-else class="text-xs capitalize font-semibold">&nbsp;</p>
              </div>
            </div>
            <span class="popper">Class : {{ d.batch_metadata.title }}</span>
          </Tooltip>
        </button>
        <button
          @click="detailPageHandler(d)"
          v-else
        >
          <div
            class="flex shadow h-full p-2 items-center border-1 border-borderColor m-1 rounded-lg"
            :class="(d.transaction_status && d.transaction_status === 'refunded') || d.status == 0 ? 'bg-gray-200' : 'bg-white'"
          >
            <img
              class="object-cover h-20 w-20 rounded"
              :src="baseUrlSrc(d.batch_metadata.min_thumbnail_url)"
              alt="..."
              @error="defaultImage"
            />
            <div class="xl:px-2 relative">
              <h5
                class="captalize text-base font-semibold text-blackgrey mb-1"
              >
                {{ handleStr(d.batch_metadata.title, 14) }}
                <span v-if="d.is_private">
                  <EyeOff />
                </span>
              </h5>
              <p class="text-gray-light text-xs mb-1">
                {{ getFormattedDate(d.start_date, d.timezone, 'MMM DD, YYYY') }}
              </p>
              <p class="text-gray-light text-xs">
                {{ getFormattedDate(d.start_date, d.timezone, 'h:mm A') }} - 
                {{ getFormattedDate(d.end_date, d.timezone, 'h:mm A') }}
              </p>
              <p
                v-if="(d.transaction_status && d.transaction_status === 'refunded') || d.status == 0"
                class="text-xs text-red-medium capitalize font-semibold mt-1"
              >
                {{d.transaction_status === 'refunded' ? 'Cancelled' : 'Cancelled by Trainer'}}
              </p>
              <p v-else class="text-xs capitalize font-semibold">&nbsp;</p>
            </div>
          </div>
        </button>
      </div>
    </div>
    <div v-if="statusCode == 404 || statusCode == 401">
      <div
        class="flex md:flex-row flex-col items-center justify-evenly px-4 py-8"
      >
        <img
          class="w-40"
          :src="require(`@/assets/svg/upcoming-sessions.svg`)"
          alt="upcoming-sessions.svg"
        />
        <div class="md:text-2xl md:px-10" v-if="statusCode == 404">
          <p>There is nothing here.</p>
          <p>Find and join new Classes to start</p>
        </div>
        <div class="md:text-2xl md:px-10" v-if="statusCode == 401">
          <p>It looks empty...</p>
          <p>Log in to see your Upcoming Classes</p>
        </div>
      </div>
    </div>
    <Modal
      :title="'Notification'" v-model="redirectWarning"
      :handleClose="closeWarningModalHandler"
    >
      <div class="rediret-warn flex flex-col items-center justify-end">
        <p>
          {{ warningObj.entity_type === 2 ? 'Class Pack' : 'Class' }} 
          contents modified. Do you want to continue ?
        </p>
        <div class="flex items-center justify-end w-full pt-6">
          <button 
            @click="redirectDetails(warningObj)"
            class="h-8 px-2 float-right text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"> 
            View {{ warningObj.entity_type === 2 ? 'Class Pack' : 'Class' }} Details
          </button>
        </div>
      </div>
    </Modal>
  </section>
</template>

<script>
import { EyeOff } from "@/components/icons";
import Tooltip from "@/components/Tooltip.vue";
import ContentLoader from "@/components/vue-spinner/ContentLoader";
import { Modal } from "@/components/t-components";

export default {
  name: "UpcomingSessionsCard",
  components: {
    ContentLoader,
    EyeOff,
    Tooltip,
    Modal
  },
  data () {
    return {
      redirectWarning: false,
      warningObj: {}
    }
  },
  props: {
    data: {
      type: Array,
      default: Array,
    },
    statusCode: {
      type: Number,
    },
  },
  computed: {
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  methods: {
    detailPageHandler (detailObj) {
      if (detailObj && detailObj.modified) {
        this.warningObj = detailObj
        this.redirectWarning = true
      } else {
        this.redirectDetails(detailObj)
      }
    },
    closeWarningModalHandler () {
      this.redirectWarning = ! this.redirectWarning
    },
    redirectDetails (detailObj) {
      if (detailObj.entity_type === 2) {
        this.$router.push({
          name: "UserCourseDetails",
          params: { id: detailObj.course_id }
        });
      } else {
        this.$router.push({
          name: "UserSessionDetails",
          params: { id: detailObj.session_id }
        });
      }
    }
  }
};
</script>